import { PagedItems } from '@texas/types';
import { SearchFilter } from './searchApi';
import {
  ProductApprovalRejectReason,
  ProductApprovalState,
} from '../productApprovalsApi';
import { Sample } from '../samplesApi';

export const defaultEmptyFilters: FilterOptionIds = {
  branchIds: [],
  categoryCodeIds: [],
  customerIds: [],
  conceptIds: [],
  supplierIds: [],
  productGroupIds: [],
  paStates: [],
};

export interface SearchBase {
  allPaIdsResult: number[];
  branchFilters: SearchFilter[];
  customerFilters: SearchFilter[];
  conceptFilters: SearchFilter[];
  supplierFilters: SearchFilter[];
  productGroupFilters: SearchFilter[];
  categoryCodeFilters: SearchFilter[];
  filterOptionIds: FilterOptionIds;
}

export interface SearchPaCountResponse extends SearchBase {
  totalCount: number;
}

export interface SearchPaResponse extends SearchBase {
  pagedItems: PagedItems<ProductApprovalItem>;
}

export interface FilterOptionIds {
  conceptIds?: number[];
  categoryCodeIds?: number[];
  customerIds?: number[];
  branchIds?: number[];
  supplierIds?: number[];
  productGroupIds?: number[];
  paStates?: number[];
}

export interface ProductApprovalItem {
  id: number;
  articleId: number;
  variantId: number;
  itemCode: string;
  name: string;
  variantName: string;
  compositionGroupId: number;
  customerId: number;
  linkedVariantId: number | null;
  customerIdentifier: string;
  customerName: string;
  concept: string;
  conceptId: number;
  branchIdentifier: string;
  branchId: number;
  productGroup: string;
  supplierName: string;
  formatNumber: string;
  state: ProductApprovalState;
  matrixNodeXValue: string | null;
  matrixNodeYValue: string | null;
  created: string;
  handledDate: string;
  handledNote: string | null;
  handledReason: ProductApprovalRejectReason[] | null;
  mainSupplier: { name: string; branch: string } | null;
  followers: { name: string; branch: string }[] | null;
  sample: Sample | null;
}

export interface PaSearchQuery extends FilterOptionIds {
  searchTerm: string;
  sortBy: string;
  sortDesc: boolean;
  page: number;
  includeArchived?: boolean;
  showMyBrands?: boolean;
  productApprovalIds?: number[];
}

export interface PaSearchQueryRequest extends PaSearchQuery {
  limit: number;
  optOutDefaultOrdering: boolean;
}
